import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AspectService } from './api/aspect.service';
import { AspectGroupService } from './api/aspectGroup.service';
import { AspectTextService } from './api/aspectText.service';
import { BusinessService } from './api/business.service';
import { BusinessCategoryService } from './api/businessCategory.service';
import { FinancierService } from './api/financier.service';
import { MethodVersionService } from './api/methodVersion.service';
import { NavigationService } from './api/navigation.service';
import { OrganizationService } from './api/organization.service';
import { ReportService } from './api/report.service';
import { ReportMetadataService } from './api/reportMetadata.service';
import { RequirementService } from './api/requirement.service';
import { StandardService } from './api/standard.service';
import { StandardGroupService } from './api/standardGroup.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
